import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=20cb51d0&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb51d0",
  null
  
)

export default component.exports